import React from "react";
import { Modal, Button, Card } from "react-bootstrap";

export const NavButton = ({ id, label, icon, active, setTab }) => (
  <button 
    className={`list-group-item list-group-item-action d-flex align-items-center py-3 border-0 rounded mb-1 ${active === id ? 'bg-primary text-white shadow-sm fw-bold' : 'text-secondary'}`} 
    onClick={() => setTab(id)}
    style={{ transition: "all 0.2s ease-in-out", borderLeft: active === id ? "4px solid #0d6efd" : "none" }}
  >
    <i className={`bi ${icon} me-3 fs-5 ${active === id ? 'text-white' : 'text-primary'}`}></i>
    <span className={active === id ? '' : ''}>{label}</span>
    {active === id && <i className="bi bi-chevron-right ms-auto small"></i>}
  </button>
);

export const KpiCard = ({ title, value, icon, bg, onClick }) => (
  <Card 
    className={`border-0 shadow-sm text-white bg-${bg} h-100 overflow-hidden`} 
    style={{ cursor: "pointer", transition: "transform 0.2s" }}
    onClick={onClick}
    onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
    onMouseOut={(e) => e.currentTarget.style.transform = "translateY(0)"}
  >
    <Card.Body className="position-relative z-1">
      <div className="display-5 fw-bold mb-1">{value}</div>
      <div className="small text-uppercase opacity-75 fw-bold letter-spacing-1">{title}</div>
      <i className={`bi ${icon} position-absolute`} style={{ 
        fontSize: "6rem", right: "-20px", top: "-20px", opacity: "0.15", transform: "rotate(15deg)", zIndex: -1
      }}></i>
    </Card.Body>
    <Card.Footer className="bg-black bg-opacity-10 border-0 text-center py-1" style={{fontSize: "0.8rem"}}>
      View Details <i className="bi bi-chevron-right ms-1"></i>
    </Card.Footer>
  </Card>
);

export const ResultModal = ({ result, onClose }) => {
  if (!result) return null;
const success = Boolean(
  result?.data?.Message_Id ||
  result?.data?.MessageId ||
  result?.status === "Success" ||
  result?.status === "Scheduled"
);

  return (
    <Modal show={!!result} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton className={success ? "bg-success text-white" : "bg-danger text-white"}>
        <Modal.Title>
  {success ? "Request Accepted" : "Operation Failed"}
</Modal.Title>

      </Modal.Header>
      <Modal.Body className="text-center p-4">
        <i className={`bi ${success ? 'bi-check-circle' : 'bi-x-circle'} display-1 ${success ? 'text-success' : 'text-danger'}`}></i>
       <h5 className="mt-3">
  {success
    ? (result.status === "Scheduled" ? "SMS Scheduled Successfully" : "SMS Sent Successfully")
    : "Error Occurred"}
</h5>
        <div className="bg-light p-3 rounded text-start mt-3 border overflow-auto" style={{maxHeight: "300px"}}>
          <pre className="m-0 small">{JSON.stringify(result.data, null, 2)}</pre>
        </div>
      </Modal.Body>
      <Modal.Footer><Button variant="secondary" onClick={onClose}>Close</Button></Modal.Footer>
    </Modal>
  );
};